import { consoleAPI } from '@/providers/apis/console/console';
import { learningRegistryAPI } from '@/providers/apis/learning-registry/learning-registry';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';

export default {
    namespaced: true,

    state: {
        categoryLists: [],
        selectedData: {},
        dropDownToolList: [],
    },

    mutations: {
        getCategoryList(state: any, categoryLists: any) {
            state.categoryLists = categoryLists;
        },

        getSelectedData(state: any, data: any) {
            state.selectedData = data;
        },

        getToolListData(state: any, data: any) {
            state.dropDownToolList = data;
        },
    },

    actions: {
        fetchCategoryList({ commit }: any) {
            let categoryLists: any;
            return taxonomyAPI.fetchTaxonomyClassifications().then(async (data: any) => {
                categoryLists = data;
                let index = 0;
                for await (const iterator of categoryLists) {
                    await taxonomyAPI.fetchSubjects(iterator.id).then((subject: any) => {
                        index++;
                        iterator.subjectList = subject;
                        if (categoryLists.length === index + 1) {
                            commit('getCategoryList', categoryLists);
                        }
                    });
                }
                return categoryLists;
            });
        },

        passSelectedData({ commit }: any, params: any) {
            commit('getSelectedData', params);
        },

        fetchDropdownToolList({ commit }: any) {
            learningRegistryAPI.fetchTooList().then(async (data: any) => {
                const studyPlayer = {
                    name : 'Study Player',
                    id: null,
                };
                data.push(studyPlayer);
                commit('getToolListData', data);
            });
        },
    },
};
